// extracted by mini-css-extract-plugin
module.exports = {"container":"jU","card":"jV","closeButton":"jW"};